// import React, { useEffect, useState } from "react";
// import {
//   Card,
//   Button,
//   Table,
//   Modal,
//   Form,
//   Input,
//   Select,
//   Row,
//   Col,
//   message,
//   Typography,
//   Spin,
//   Space,
//   Tag,
//   Popconfirm,
//   Tooltip,
//   Empty,
//   Badge,
//   Divider,
//   InputNumber,
//   DatePicker,
// } from "antd";
// import {
//   PlusOutlined,
//   EditOutlined,
//   DeleteOutlined,
//   CrownOutlined,
//   CheckCircleOutlined,
//   CloseCircleOutlined,
//   CalendarOutlined,
//   DollarOutlined,
//   AppstoreOutlined,
//   ClockCircleOutlined,
// } from "@ant-design/icons";
// import { useParams } from "react-router-dom";
// import { getServiceApi } from "../../services/serviceApi";
// import moment from "moment";

// const { Title, Text, Paragraph } = Typography;
// const { Option } = Select;
// const { TextArea } = Input;

// export default function PlanManagement() {
//   const [plans, setPlans] = useState([]);
//   const [services, setServices] = useState([]);
//   const [modalVisible, setModalVisible] = useState(false);
//   const [editingPlan, setEditingPlan] = useState(null);
//   const [form] = Form.useForm();
//   const [loading, setLoading] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [validityType, setValidityType] = useState("months");
  
//   const { companyId } = useParams();

//   useEffect(() => {
//     fetchServices();
//     fetchPlans();
//   }, []);

//   const fetchServices = async () => {
//     try {
//       setLoading(true);
//       const res = await getServiceApi({ companyId });
//       setServices(res || []);
//     } catch (err) {
//       message.error("Failed to fetch services");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchPlans = async () => {
//     try {
//       setLoading(true);
//       // TODO: Replace with actual API call
//       // const res = await getPlansApi({ companyId });
//       // setPlans(res || []);
      
//       // Mock data for demonstration
//       setPlans([
//         {
//           _id: "1",
//           name: "Basic Plan",
//           description: "Perfect for occasional visits",
//           price: 2999,
//           validityType: "months",
//           validityValue: 3,
//           services: ["service1", "service2"],
//           status: "active",
//           createdAt: new Date(),
//         },
//       ]);
//     } catch (err) {
//       message.error("Failed to fetch plans");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAddPlan = () => {
//     setEditingPlan(null);
//     form.resetFields();
//     setValidityType("months");
//     setModalVisible(true);
//   };

//   const handleEditPlan = (plan) => {
//     setEditingPlan(plan);
//     setValidityType(plan.validityType || "months");
    
//     form.setFieldsValue({
//       name: plan.name,
//       description: plan.description,
//       price: plan.price,
//       validityType: plan.validityType,
//       validityValue: plan.validityValue,
//       customDate: plan.customDate ? moment(plan.customDate) : null,
//       services: plan.services,
//       status: plan.status,
//     });
    
//     setModalVisible(true);
//   };

//   const handleDeletePlan = async (planId) => {
//     try {
//       // TODO: Replace with actual API call
//       // await deletePlanApi(companyId, planId);
      
//       setPlans(plans.filter(plan => plan._id !== planId));
//       message.success("Plan deleted successfully");
//     } catch (err) {
//       message.error("Failed to delete plan");
//     }
//   };

//   const handleSubmit = async (values) => {
//     try {
//       setSubmitting(true);
      
//       const payload = {
//         ...values,
//         companyId,
//         validityType,
//         customDate: values.customDate ? values.customDate.format("YYYY-MM-DD") : null,
//       };

//       if (editingPlan) {
//         // TODO: Replace with actual API call
//         // await updatePlanApi(companyId, editingPlan._id, payload);
        
//         setPlans(plans.map(plan => 
//           plan._id === editingPlan._id 
//             ? { ...plan, ...payload }
//             : plan
//         ));
//         message.success("Plan updated successfully");
//       } else {
//         // TODO: Replace with actual API call
//         // const res = await createPlanApi(companyId, payload);
        
//         const newPlan = {
//           _id: Date.now().toString(),
//           ...payload,
//           createdAt: new Date(),
//         };
        
//         setPlans([...plans, newPlan]);
//         message.success("Plan created successfully");
//       }

//       setModalVisible(false);
//       form.resetFields();
//       setEditingPlan(null);
//     } catch (err) {
//       message.error("Failed to save plan");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const getValidityText = (plan) => {
//     if (plan.validityType === "custom" && plan.customDate) {
//       return `Until ${moment(plan.customDate).format("DD MMM YYYY")}`;
//     }
    
//     if (plan.validityType === "months") {
//       return `${plan.validityValue} Month${plan.validityValue > 1 ? 's' : ''}`;
//     }
    
//     if (plan.validityType === "days") {
//       return `${plan.validityValue} Day${plan.validityValue > 1 ? 's' : ''}`;
//     }
    
//     return "N/A";
//   };

//   const getServiceNames = (serviceIds) => {
//     return serviceIds
//       .map(id => services.find(s => s._id === id)?.name)
//       .filter(Boolean)
//       .join(", ");
//   };

//   const columns = [
//     {
//       title: "Plan Name",
//       dataIndex: "name",
//       key: "name",
//       render: (text) => (
//         <Space>
//           <CrownOutlined style={{ color: "#faad14" }} />
//           <Text strong>{text}</Text>
//         </Space>
//       ),
//     },
//     {
//       title: "Description",
//       dataIndex: "description",
//       key: "description",
//       ellipsis: true,
//       render: (text) => (
//         <Tooltip title={text}>
//           <Text type="secondary">{text}</Text>
//         </Tooltip>
//       ),
//     },
//     {
//       title: "Price",
//       dataIndex: "price",
//       key: "price",
//       render: (price) => (
//         <Text strong style={{ color: "#52c41a" }}>
//           ₹{price}
//         </Text>
//       ),
//     },
//     {
//       title: "Validity",
//       key: "validity",
//       render: (_, record) => (
//         <Tag color="blue" icon={<ClockCircleOutlined />}>
//           {getValidityText(record)}
//         </Tag>
//       ),
//     },
//     {
//       title: "Services Included",
//       dataIndex: "services",
//       key: "services",
//       render: (serviceIds) => (
//         <Tooltip title={getServiceNames(serviceIds)}>
//           <Badge count={serviceIds?.length || 0} style={{ backgroundColor: "#1890ff" }}>
//             <Tag color="purple">
//               <AppstoreOutlined /> Services
//             </Tag>
//           </Badge>
//         </Tooltip>
//       ),
//     },
//     {
//       title: "Status",
//       dataIndex: "status",
//       key: "status",
//       render: (status) => (
//         <Tag
//           color={status === "active" ? "success" : "error"}
//           icon={status === "active" ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
//         >
//           {status === "active" ? "Active" : "Inactive"}
//         </Tag>
//       ),
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       fixed: "right",
//       width: 120,
//       render: (_, record) => (
//         <Space>
//           <Tooltip title="Edit Plan">
//             <Button
//               type="primary"
//               ghost
//               icon={<EditOutlined />}
//               onClick={() => handleEditPlan(record)}
//               size="small"
//             />
//           </Tooltip>
//           <Tooltip title="Delete Plan">
//             <Popconfirm
//               title="Delete Plan"
//               description="Are you sure you want to delete this plan?"
//               onConfirm={() => handleDeletePlan(record._id)}
//               okText="Yes"
//               cancelText="No"
//               okButtonProps={{ danger: true }}
//             >
//               <Button
//                 danger
//                 icon={<DeleteOutlined />}
//                 size="small"
//               />
//             </Popconfirm>
//           </Tooltip>
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//         padding: "24px",
//       }}
//     >
//       <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
//         {/* Header */}
//         <div
//           style={{
//             background: "white",
//             borderRadius: "20px",
//             padding: "32px",
//             marginBottom: "24px",
//             boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
//           }}
//         >
//           <Row align="middle" justify="space-between">
//             <Col>
//               <Title
//                 level={2}
//                 style={{
//                   margin: 0,
//                   marginBottom: "8px",
//                   background: "linear-gradient(45deg, #faad14, #ff7a45)",
//                   WebkitBackgroundClip: "text",
//                   WebkitTextFillColor: "transparent",
//                   fontSize: "32px",
//                 }}
//               >
//                 <CrownOutlined style={{ marginRight: "12px" }} />
//                 Membership Plans
//               </Title>
//               <Text type="secondary" style={{ fontSize: "16px" }}>
//                 Create and manage salon membership plans
//               </Text>
//             </Col>
//             <Col>
//               <Button
//                 type="primary"
//                 size="large"
//                 icon={<PlusOutlined />}
//                 onClick={handleAddPlan}
//                 style={{
//                   borderRadius: "12px",
//                   background: "linear-gradient(45deg, #faad14, #ff7a45)",
//                   border: "none",
//                   boxShadow: "0 4px 12px rgba(250,173,20,0.4)",
//                   height: "48px",
//                   fontSize: "16px",
//                 }}
//               >
//                 Create New Plan
//               </Button>
//             </Col>
//           </Row>
//         </div>

//         {/* Plans Table */}
//         <div
//           style={{
//             background: "white",
//             borderRadius: "20px",
//             padding: "24px",
//             boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
//           }}
//         >
//           <Table
//             columns={columns}
//             dataSource={plans}
//             rowKey="_id"
//             loading={loading}
//             pagination={{
//               pageSize: 10,
//               showSizeChanger: true,
//               showTotal: (total) => `Total ${total} plans`,
//             }}
//             scroll={{ x: 1200 }}
//             locale={{
//               emptyText: (
//                 <Empty
//                   description="No membership plans found"
//                   image={Empty.PRESENTED_IMAGE_SIMPLE}
//                 >
//                   <Button
//                     type="primary"
//                     icon={<PlusOutlined />}
//                     onClick={handleAddPlan}
//                   >
//                     Create First Plan
//                   </Button>
//                 </Empty>
//               ),
//             }}
//           />
//         </div>
//       </div>

//       {/* Create/Edit Plan Modal */}
//       <Modal
//         title={
//           <div style={{ fontSize: "20px", fontWeight: "bold" }}>
//             <CrownOutlined style={{ marginRight: "8px", color: "#faad14" }} />
//             {editingPlan ? "Edit Membership Plan" : "Create New Membership Plan"}
//           </div>
//         }
//         open={modalVisible}
//         onCancel={() => {
//           setModalVisible(false);
//           form.resetFields();
//           setEditingPlan(null);
//         }}
//         footer={null}
//         width={700}
//         destroyOnClose
//       >
//         <Form
//           form={form}
//           layout="vertical"
//           onFinish={handleSubmit}
//           initialValues={{
//             status: "active",
//             validityType: "months",
//             validityValue: 3,
//           }}
//         >
//           <Title level={4} style={{ color: "#faad14", marginBottom: "16px" }}>
//             Plan Details
//           </Title>

//           <Form.Item
//             name="name"
//             label={
//               <Text strong>
//                 <CrownOutlined style={{ marginRight: "4px" }} />
//                 Plan Name
//               </Text>
//             }
//             rules={[{ required: true, message: "Please enter plan name" }]}
//           >
//             <Input
//               placeholder="e.g., Premium Membership, Basic Package"
//               size="large"
//               style={{ borderRadius: "8px" }}
//             />
//           </Form.Item>

//           <Form.Item
//             name="description"
//             label={
//               <Text strong>
//                 Description
//               </Text>
//             }
//             rules={[{ required: true, message: "Please enter plan description" }]}
//           >
//             <TextArea
//               placeholder="Describe what's included in this membership plan"
//               rows={3}
//               style={{ borderRadius: "8px" }}
//             />
//           </Form.Item>

//           <Row gutter={16}>
//             <Col span={12}>
//               <Form.Item
//                 name="price"
//                 label={
//                   <Text strong>
//                     <DollarOutlined style={{ marginRight: "4px" }} />
//                     Plan Price (₹)
//                   </Text>
//                 }
//                 rules={[{ required: true, message: "Please enter price" }]}
//               >
//                 <InputNumber
//                   placeholder="0"
//                   size="large"
//                   style={{ width: "100%", borderRadius: "8px" }}
//                   min={0}
//                   formatter={(value) => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
//                   parser={(value) => value.replace(/₹\s?|(,*)/g, "")}
//                 />
//               </Form.Item>
//             </Col>
//             <Col span={12}>
//               <Form.Item
//                 name="status"
//                 label={
//                   <Text strong>
//                     Status
//                   </Text>
//                 }
//                 rules={[{ required: true, message: "Please select status" }]}
//               >
//                 <Select size="large" style={{ borderRadius: "8px" }}>
//                   <Option value="active">
//                     <Space>
//                       <CheckCircleOutlined style={{ color: "#52c41a" }} />
//                       <span>Active</span>
//                     </Space>
//                   </Option>
//                   <Option value="inactive">
//                     <Space>
//                       <CloseCircleOutlined style={{ color: "#ff4d4f" }} />
//                       <span>Inactive</span>
//                     </Space>
//                   </Option>
//                 </Select>
//               </Form.Item>
//             </Col>
//           </Row>

//           <Divider />

//           <Title level={4} style={{ color: "#faad14", marginBottom: "16px" }}>
//             Plan Validity
//           </Title>

//           <Form.Item
//             name="validityType"
//             label={
//               <Text strong>
//                 <ClockCircleOutlined style={{ marginRight: "4px" }} />
//                 Validity Type
//               </Text>
//             }
//             rules={[{ required: true, message: "Please select validity type" }]}
//           >
//             <Select
//               size="large"
//               style={{ borderRadius: "8px" }}
//               onChange={(value) => setValidityType(value)}
//             >
//               <Option value="months">
//                 <Space>
//                   <CalendarOutlined style={{ color: "#1890ff" }} />
//                   <span>Months</span>
//                 </Space>
//               </Option>
//               <Option value="days">
//                 <Space>
//                   <ClockCircleOutlined style={{ color: "#52c41a" }} />
//                   <span>Days</span>
//                 </Space>
//               </Option>
//               <Option value="custom">
//                 <Space>
//                   <CalendarOutlined style={{ color: "#722ed1" }} />
//                   <span>Custom Date</span>
//                 </Space>
//               </Option>
//             </Select>
//           </Form.Item>

//           {validityType === "custom" ? (
//             <Form.Item
//               name="customDate"
//               label={
//                 <Text strong>
//                   Valid Until
//                 </Text>
//               }
//               rules={[{ required: true, message: "Please select expiry date" }]}
//             >
//               <DatePicker
//                 size="large"
//                 style={{ width: "100%", borderRadius: "8px" }}
//                 placeholder="Select expiry date"
//                 disabledDate={(current) => current && current.isBefore(moment(), "day")}
//                 format="DD/MM/YYYY"
//               />
//             </Form.Item>
//           ) : (
//             <Form.Item
//               name="validityValue"
//               label={
//                 <Text strong>
//                   Validity Duration
//                 </Text>
//               }
//               rules={[{ required: true, message: "Please enter validity duration" }]}
//             >
//               <InputNumber
//                 placeholder={validityType === "months" ? "e.g., 3, 6, 12" : "e.g., 30, 90, 180"}
//                 size="large"
//                 style={{ width: "100%", borderRadius: "8px" }}
//                 min={1}
//                 addonAfter={validityType === "months" ? "Months" : "Days"}
//               />
//             </Form.Item>
//           )}

//           <div
//             style={{
//               background: "#fff7e6",
//               border: "1px solid #ffd591",
//               borderRadius: "8px",
//               padding: "12px",
//               marginBottom: "24px",
//             }}
//           >
//             <Space>
//               <ClockCircleOutlined style={{ color: "#faad14" }} />
//               <Text style={{ fontSize: "12px", color: "#d46b08" }}>
//                 <strong>Note:</strong> Members will have access to selected services for the specified validity period.
//               </Text>
//             </Space>
//           </div>

//           <Divider />

//           <Title level={4} style={{ color: "#faad14", marginBottom: "16px" }}>
//             Included Services
//           </Title>

//           <Form.Item
//             name="services"
//             label={
//               <Text strong>
//                 <AppstoreOutlined style={{ marginRight: "4px" }} />
//                 Select Services
//               </Text>
//             }
//             rules={[
//               { required: true, message: "Please select at least one service" },
//               {
//                 validator: (_, value) => {
//                   if (value && value.length > 0) {
//                     return Promise.resolve();
//                   }
//                   return Promise.reject(new Error("Select at least one service"));
//                 },
//               },
//             ]}
//           >
//             <Select
//               mode="multiple"
//               size="large"
//               placeholder="Select services included in this plan"
//               style={{ borderRadius: "8px" }}
//               optionFilterProp="children"
//               filterOption={(input, option) =>
//                 option.children.toLowerCase().includes(input.toLowerCase())
//               }
//               maxTagCount="responsive"
//             >
//               {services.map((service) => (
//                 <Option key={service._id} value={service._id}>
//                   <Space>
//                     <Text>{service.name}</Text>
//                     <Text type="secondary" style={{ fontSize: "12px" }}>
//                       (₹{service.price})
//                     </Text>
//                   </Space>
//                 </Option>
//               ))}
//             </Select>
//           </Form.Item>

//           <div
//             style={{
//               background: "#e6f7ff",
//               border: "1px solid #91d5ff",
//               borderRadius: "8px",
//               padding: "12px",
//               marginBottom: "24px",
//             }}
//           >
//             <Space>
//               <CheckCircleOutlined style={{ color: "#1890ff" }} />
//               <Text style={{ fontSize: "12px", color: "#0958d9" }}>
//                 Members can avail any of the selected services during the plan validity period.
//               </Text>
//             </Space>
//           </div>

//           <Form.Item style={{ marginTop: "32px", marginBottom: 0 }}>
//             <Space style={{ width: "100%", justifyContent: "flex-end" }}>
//               <Button
//                 size="large"
//                 onClick={() => {
//                   setModalVisible(false);
//                   form.resetFields();
//                   setEditingPlan(null);
//                 }}
//                 style={{ borderRadius: "8px" }}
//               >
//                 Cancel
//               </Button>
//               <Button
//                 type="primary"
//                 htmlType="submit"
//                 size="large"
//                 loading={submitting}
//                 style={{
//                   borderRadius: "8px",
//                   background: "linear-gradient(45deg, #faad14, #ff7a45)",
//                   border: "none",
//                   minWidth: "120px",
//                 }}
//               >
//                 {submitting
//                   ? editingPlan
//                     ? "Updating..."
//                     : "Creating..."
//                   : editingPlan
//                   ? "Update Plan"
//                   : "Create Plan"}
//               </Button>
//             </Space>
//           </Form.Item>
//         </Form>
//       </Modal>
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import {
  Card,
  Button,
  Table,
  Modal,
  Form,
  Input,
  Select,
  Row,
  Col,
  message,
  Typography,
  Spin,
  Space,
  Tag,
  Popconfirm,
  Tooltip,
  Empty,
  Badge,
  Divider,
  InputNumber,
  DatePicker,
  Switch,
  List,
} from "antd";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  CrownOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  CalendarOutlined,
  DollarOutlined,
  AppstoreOutlined,
  ClockCircleOutlined,
  GiftOutlined,
  MinusCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import { getServiceApi } from "../../services/serviceApi";
import { 
  getPlans, 
  createPlan, 
  updatePlan, 
  deletePlan 
} from "../../services/planService";
import moment from "moment";
import { toast } from "react-toastify";

const { Title, Text, Paragraph } = Typography;
const { Option } = Select;
const { TextArea } = Input;

export default function PlanManagement() {
  const [plans, setPlans] = useState([]);
  const [services, setServices] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingPlan, setEditingPlan] = useState(null);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [validityType, setValidityType] = useState("months");
  const [serviceList, setServiceList] = useState([]);
  
  const { companyId } = useParams();

  useEffect(() => {
    fetchServices();
    fetchPlans();
  }, []);

  const fetchServices = async () => {
    try {
      setLoading(true);
      const res = await getServiceApi({ companyId });
      setServices(res || []);
    } catch (err) {
      message.error("Failed to fetch services");
    } finally {
      setLoading(false);
    }
  };

  const fetchPlans = async () => {
    try {
      setLoading(true);
      const res = await getPlans({ companyId });
      
      console.log("Plans API Response:", res); // Debug log
      
      // Handle different response structures
      let plansData = [];
      if (res?.data?.data) {
        // Structure: { data: { data: [...] } }
        plansData = res.data.data;
      } else if (res?.data) {
        // Structure: { data: [...] }
        plansData = res.data;
      }
      
      console.log("Processed plans data:", plansData); // Debug log
      
      // Ensure it's an array
      const finalPlans = Array.isArray(plansData) ? plansData : [];
      setPlans(finalPlans);
      
      if (finalPlans.length === 0) {
        console.log("No plans found");
      }
    } catch (err) {
      console.error("Error fetching plans:", err);
      message.error("Failed to fetch plans");
    } finally {
      setLoading(false);
    }
  };

  const handleAddPlan = () => {
    setEditingPlan(null);
    form.resetFields();
    setValidityType("months");
    setServiceList([]);
    setModalVisible(true);
  };

  const handleEditPlan = (plan) => {
    setEditingPlan(plan);
    setValidityType(plan.validityType || "months");
    
    // Set service list for editing
    // serviceId may be a populated object or a plain ID string
    const formattedServices = plan.serviceList?.map(service => ({
      serviceId: service.serviceId?._id || service.serviceId || service._id || service.id,
      repeatCount: service.repeatCount || 1,
      isComplimentary: service.isComplimentary || false,
    })) || [];
    
    setServiceList(formattedServices);
    
    form.setFieldsValue({
      name: plan.name,
      description: plan.description,
      price: plan.price,
      validityType: plan.validityType,
      validityValue: plan.validityValue,
      customDate: plan.customDate ? moment(plan.customDate) : null,
      status: plan.status,
    });
    
    setModalVisible(true);
  };

  const handleDeletePlan = async (planId) => {
    try {
      await deletePlan(planId);
      setPlans(plans.filter(plan => plan._id !== planId));
      toast.success("Plan deleted successfully");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to delete plan");
    }
  };

  const handleAddService = () => {
    setServiceList([
      ...serviceList,
      { serviceId: undefined, repeatCount: 1, isComplimentary: false }
    ]);
  };

  const handleRemoveService = (index) => {
    const newList = serviceList.filter((_, i) => i !== index);
    setServiceList(newList);
  };

  const handleServiceChange = (index, field, value) => {
    const newList = [...serviceList];
    newList[index][field] = value;
    setServiceList(newList);
  };

  const handleSubmit = async (values) => {
    try {
      // Validate service list
      if (serviceList.length === 0) {
        message.error("Please add at least one service");
        return;
      }

      // Check for duplicate services
      const serviceIds = serviceList.map(s => s.serviceId);
      const uniqueServiceIds = new Set(serviceIds);
      if (serviceIds.length !== uniqueServiceIds.size) {
        message.error("Duplicate services found. Each service can only be added once.");
        return;
      }

      // Check if all services are selected
      if (serviceList.some(s => !s.serviceId)) {
        message.error("Please select a service for all rows");
        return;
      }

      setSubmitting(true);
      
      const payload = {
        ...values,
        companyId,
        validityType,
        customDate: values.customDate ? values.customDate.format("YYYY-MM-DD") : null,
        serviceList: serviceList.map(service => ({
          serviceId: service.serviceId,
          repeatCount: service.repeatCount || 1,
          isComplimentary: service.isComplimentary || false,
        })),
      };

      let response;
      if (editingPlan) {
        response = await updatePlan(editingPlan._id, payload);
        toast.success("Plan updated successfully");
      } else {
        response = await createPlan(payload);
        toast.success("Plan created successfully");
      }

      await fetchPlans(); // Refresh the list
      setModalVisible(false);
      form.resetFields();
      setServiceList([]);
      setEditingPlan(null);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save plan");
    } finally {
      setSubmitting(false);
    }
  };

  const getValidityText = (plan) => {
    if (plan.validityType === "custom" && plan.customDate) {
      return `Until ${moment(plan.customDate).format("DD MMM YYYY")}`;
    }
    
    if (plan.validityType === "months") {
      return `${plan.validityValue} Month${plan.validityValue > 1 ? 's' : ''}`;
    }
    
    if (plan.validityType === "days") {
      return `${plan.validityValue} Day${plan.validityValue > 1 ? 's' : ''}`;
    }
    
    return "N/A";
  };

  const getServiceName = (serviceId) => {
    const service = services.find(s => s._id === serviceId);
    return service?.name || "Unknown Service";
  };

  const getTotalServices = (plan) => {
    if (!plan || !plan.serviceList || !Array.isArray(plan.serviceList)) {
      return 0;
    }
    return plan.serviceList.reduce((total, service) => total + (service.repeatCount || 1), 0);
  };

  const getComplimentaryCount = (plan) => {
    if (!plan || !plan.serviceList || !Array.isArray(plan.serviceList)) {
      return 0;
    }
    return plan.serviceList.filter(service => service.isComplimentary).length;
  };

  const columns = [
    {
      title: "Plan Name",
      dataIndex: "name",
      key: "name",
      render: (text) => (
        <Space>
          <CrownOutlined style={{ color: "#faad14" }} />
          <Text strong>{text}</Text>
        </Space>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
      render: (text) => (
        <Tooltip title={text}>
          <Text type="secondary">{text}</Text>
        </Tooltip>
      ),
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: (price) => (
        <Text strong style={{ color: "#52c41a" }}>
          ₹{price}
        </Text>
      ),
    },
    {
      title: "Validity",
      key: "validity",
      render: (_, record) => (
        <Tag color="blue" icon={<ClockCircleOutlined />}>
          {getValidityText(record)}
        </Tag>
      ),
    },
    {
      title: "Services",
      key: "services",
      render: (_, record) => (
        <Space direction="vertical" size={0}>
          <Badge 
            count={getTotalServices(record)} 
            style={{ backgroundColor: "#1890ff" }}
            showZero
          >
            <Tag color="purple">
              <AppstoreOutlined /> Total Uses
            </Tag>
          </Badge>
          {getComplimentaryCount(record) > 0 && (
            <Badge 
              count={getComplimentaryCount(record)} 
              style={{ backgroundColor: "#52c41a" }}
            >
              <Tag color="green">
                <GiftOutlined /> Complimentary
              </Tag>
            </Badge>
          )}
        </Space>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag
          color={status === "active" ? "success" : "error"}
          icon={status === "active" ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
        >
          {status === "active" ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right",
      width: 120,
      render: (_, record) => (
        <Space>
          <Tooltip title="Edit Plan">
            <Button
              type="primary"
              ghost
              icon={<EditOutlined />}
              onClick={() => handleEditPlan(record)}
              size="small"
            />
          </Tooltip>
          <Tooltip title="Delete Plan">
            <Popconfirm
              title="Delete Plan"
              description="Are you sure you want to delete this plan?"
              onConfirm={() => handleDeletePlan(record._id)}
              okText="Yes"
              cancelText="No"
              okButtonProps={{ danger: true }}
            >
              <Button
                danger
                icon={<DeleteOutlined />}
                size="small"
              />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        padding: "24px",
      }}
    >
      <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
        {/* Header */}
        <div
          style={{
            background: "white",
            borderRadius: "20px",
            padding: "32px",
            marginBottom: "24px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
          }}
        >
          <Row align="middle" justify="space-between">
            <Col>
              <Title
                level={2}
                style={{
                  margin: 0,
                  marginBottom: "8px",
                  background: "linear-gradient(45deg, #faad14, #ff7a45)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: "32px",
                }}
              >
                <CrownOutlined style={{ marginRight: "12px" }} />
                Membership Plans
              </Title>
              <Text type="secondary" style={{ fontSize: "16px" }}>
                Create and manage salon membership plans with service allocations
              </Text>
            </Col>
            <Col>
              <Button
                type="primary"
                size="large"
                icon={<PlusOutlined />}
                onClick={handleAddPlan}
                style={{
                  borderRadius: "12px",
                  background: "linear-gradient(45deg, #faad14, #ff7a45)",
                  border: "none",
                  boxShadow: "0 4px 12px rgba(250,173,20,0.4)",
                  height: "48px",
                  fontSize: "16px",
                }}
              >
                Create New Plan
              </Button>
            </Col>
          </Row>
        </div>

        {/* Plans Table */}
        <div
          style={{
            background: "white",
            borderRadius: "20px",
            padding: "24px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
          }}
        >
          <Table
            columns={columns}
            dataSource={plans}
            rowKey="_id"
            loading={loading}
            pagination={{
              pageSize: 10,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} plans`,
            }}
            scroll={{ x: 1200 }}
            locale={{
              emptyText: (
                <Empty
                  description="No membership plans found"
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                >
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={handleAddPlan}
                  >
                    Create First Plan
                  </Button>
                </Empty>
              ),
            }}
            expandable={{
              expandedRowRender: (record) => (
                <div style={{ padding: "16px", background: "#fafafa", borderRadius: "8px" }}>
                  <Title level={5} style={{ marginBottom: "16px" }}>
                    <AppstoreOutlined style={{ marginRight: "8px", color: "#1890ff" }} />
                    Included Services
                  </Title>
                  <List
                    dataSource={record.serviceList || []}
                    renderItem={(item) => (
                      <List.Item>
                        <Space size="large" style={{ width: "100%" }}>
                          <Text strong style={{ minWidth: "200px" }}>
                            {getServiceName(item.serviceId || item.id)}
                          </Text>
                          <Tag color="blue">
                            {item.repeatCount || 1}x Usage{item.repeatCount > 1 ? 's' : ''}
                          </Tag>
                          {item.isComplimentary && (
                            <Tag color="green" icon={<GiftOutlined />}>
                              Complimentary
                            </Tag>
                          )}
                        </Space>
                      </List.Item>
                    )}
                  />
                </div>
              ),
            }}
          />
        </div>
      </div>

      {/* Create/Edit Plan Modal */}
      <Modal
        title={
          <div style={{ fontSize: "20px", fontWeight: "bold" }}>
            <CrownOutlined style={{ marginRight: "8px", color: "#faad14" }} />
            {editingPlan ? "Edit Membership Plan" : "Create New Membership Plan"}
          </div>
        }
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          form.resetFields();
          setServiceList([]);
          setEditingPlan(null);
        }}
        footer={null}
        width={800}
        destroyOnClose
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            status: "active",
            validityType: "months",
            validityValue: 3,
          }}
        >
          <Title level={4} style={{ color: "#faad14", marginBottom: "16px" }}>
            Plan Details
          </Title>

          <Form.Item
            name="name"
            label={
              <Text strong>
                <CrownOutlined style={{ marginRight: "4px" }} />
                Plan Name
              </Text>
            }
            rules={[{ required: true, message: "Please enter plan name" }]}
          >
            <Input
              placeholder="e.g., Premium Membership, Basic Package"
              size="large"
              style={{ borderRadius: "8px" }}
            />
          </Form.Item>

          <Form.Item
            name="description"
            label={
              <Text strong>
                Description
              </Text>
            }
            rules={[{ required: true, message: "Please enter plan description" }]}
          >
            <TextArea
              placeholder="Describe what's included in this membership plan"
              rows={3}
              style={{ borderRadius: "8px" }}
            />
          </Form.Item>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="price"
                label={
                  <Text strong>
                    <DollarOutlined style={{ marginRight: "4px" }} />
                    Plan Price (₹)
                  </Text>
                }
                rules={[{ required: true, message: "Please enter price" }]}
              >
                <InputNumber
                  placeholder="0"
                  size="large"
                  style={{ width: "100%", borderRadius: "8px" }}
                  min={0}
                  formatter={(value) => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  parser={(value) => value.replace(/₹\s?|(,*)/g, "")}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="status"
                label={
                  <Text strong>
                    Status
                  </Text>
                }
                rules={[{ required: true, message: "Please select status" }]}
              >
                <Select size="large" style={{ borderRadius: "8px" }}>
                  <Option value="active">
                    <Space>
                      <CheckCircleOutlined style={{ color: "#52c41a" }} />
                      <span>Active</span>
                    </Space>
                  </Option>
                  <Option value="inactive">
                    <Space>
                      <CloseCircleOutlined style={{ color: "#ff4d4f" }} />
                      <span>Inactive</span>
                    </Space>
                  </Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Divider />

          <Title level={4} style={{ color: "#faad14", marginBottom: "16px" }}>
            Plan Validity
          </Title>

          <Form.Item
            name="validityType"
            label={
              <Text strong>
                <ClockCircleOutlined style={{ marginRight: "4px" }} />
                Validity Type
              </Text>
            }
            rules={[{ required: true, message: "Please select validity type" }]}
          >
            <Select
              size="large"
              style={{ borderRadius: "8px" }}
              onChange={(value) => setValidityType(value)}
            >
              <Option value="months">
                <Space>
                  <CalendarOutlined style={{ color: "#1890ff" }} />
                  <span>Months</span>
                </Space>
              </Option>
              <Option value="days">
                <Space>
                  <ClockCircleOutlined style={{ color: "#52c41a" }} />
                  <span>Days</span>
                </Space>
              </Option>
              <Option value="custom">
                <Space>
                  <CalendarOutlined style={{ color: "#722ed1" }} />
                  <span>Custom Date</span>
                </Space>
              </Option>
            </Select>
          </Form.Item>

          {validityType === "custom" ? (
            <Form.Item
              name="customDate"
              label={
                <Text strong>
                  Valid Until
                </Text>
              }
              rules={[{ required: true, message: "Please select expiry date" }]}
            >
              <DatePicker
                size="large"
                style={{ width: "100%", borderRadius: "8px" }}
                placeholder="Select expiry date"
                disabledDate={(current) => current && current.isBefore(moment(), "day")}
                format="DD/MM/YYYY"
              />
            </Form.Item>
          ) : (
            <Form.Item
              name="validityValue"
              label={
                <Text strong>
                  Validity Duration
                </Text>
              }
              rules={[{ required: true, message: "Please enter validity duration" }]}
            >
              <InputNumber
                placeholder={validityType === "months" ? "e.g., 3, 6, 12" : "e.g., 30, 90, 180"}
                size="large"
                style={{ width: "100%", borderRadius: "8px" }}
                min={1}
                addonAfter={validityType === "months" ? "Months" : "Days"}
              />
            </Form.Item>
          )}

          <Divider />

          <Title level={4} style={{ color: "#faad14", marginBottom: "16px" }}>
            <AppstoreOutlined style={{ marginRight: "8px" }} />
            Service Allocation
          </Title>

          <div
            style={{
              background: "#e6f7ff",
              border: "1px solid #91d5ff",
              borderRadius: "8px",
              padding: "12px",
              marginBottom: "16px",
            }}
          >
            <Space>
              <InfoCircleOutlined style={{ color: "#1890ff" }} />
              <Text style={{ fontSize: "12px", color: "#0958d9" }}>
                Specify how many times each service can be used during the membership period. Mark services as complimentary for free bonus services.
              </Text>
            </Space>
          </div>

          {serviceList.map((service, index) => (
            <Card
              key={index}
              size="small"
              style={{ marginBottom: "12px", borderRadius: "8px" }}
              bodyStyle={{ padding: "12px" }}
            >
              <Row gutter={12} align="middle">
                <Col span={10}>
                  <Text type="secondary" style={{ fontSize: "12px" }}>Service</Text>
                  <Select
                    placeholder="Select service"
                    value={service.serviceId}
                    onChange={(value) => handleServiceChange(index, 'serviceId', value)}
                    style={{ width: "100%", marginTop: "4px" }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {services.map((s) => (
                      <Option 
                        key={s._id} 
                        value={s._id}
                        disabled={serviceList.some((item, i) => i !== index && item.serviceId === s._id)}
                      >
                        {s.name} (₹{s.price})
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col span={6}>
                  <Text type="secondary" style={{ fontSize: "12px" }}>Repeat Count</Text>
                  <InputNumber
                    placeholder="Times"
                    value={service.repeatCount}
                    onChange={(value) => handleServiceChange(index, 'repeatCount', value)}
                    min={1}
                    max={100}
                    style={{ width: "100%", marginTop: "4px" }}
                  />
                </Col>
                <Col span={6}>
                  <Text type="secondary" style={{ fontSize: "12px" }}>Complimentary</Text>
                  <div style={{ marginTop: "8px" }}>
                    <Switch
                      checked={service.isComplimentary}
                      onChange={(checked) => handleServiceChange(index, 'isComplimentary', checked)}
                      checkedChildren={<GiftOutlined />}
                      unCheckedChildren="No"
                    />
                  </div>
                </Col>
                <Col span={2}>
                  <Button
                    type="text"
                    danger
                    icon={<MinusCircleOutlined />}
                    onClick={() => handleRemoveService(index)}
                    style={{ marginTop: "16px" }}
                  />
                </Col>
              </Row>
            </Card>
          ))}

          <Button
            type="dashed"
            onClick={handleAddService}
            block
            icon={<PlusOutlined />}
            style={{ marginBottom: "24px", borderRadius: "8px" }}
          >
            Add Service
          </Button>

          <Form.Item style={{ marginTop: "32px", marginBottom: 0 }}>
            <Space style={{ width: "100%", justifyContent: "flex-end" }}>
              <Button
                size="large"
                onClick={() => {
                  setModalVisible(false);
                  form.resetFields();
                  setServiceList([]);
                  setEditingPlan(null);
                }}
                style={{ borderRadius: "8px" }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                loading={submitting}
                style={{
                  borderRadius: "8px",
                  background: "linear-gradient(45deg, #faad14, #ff7a45)",
                  border: "none",
                  minWidth: "120px",
                }}
              >
                {submitting
                  ? editingPlan
                    ? "Updating..."
                    : "Creating..."
                  : editingPlan
                  ? "Update Plan"
                  : "Create Plan"}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}